export default {
  namespaced: true,
  state: () => ({
    dropdown: "closed",
    sidebar: false,
  }),
  mutations: {
    SET_STATE(state, input) {
      state.dropdown = input;
    },
    SET_SIDEBAR(state, input) {
      state.sidebar = input;
    },
  },
  getters: {
    dropdownState(state) {
      return state.dropdown;
    },
    sidebar(state) {
      return state.sidebar;
    },
  },
  actions: {
    setDropdownType({ commit }, input) {
      commit("SET_STATE", input);
    },
    toggleSideBar({ state, commit }) {
      commit("SET_SIDEBAR", !state.sidebar);
    },
    hideSideBar({ commit }) {
      commit("SET_SIDEBAR", false);
    },
  },
};
